import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b7e5e046")

_pushScopeId("data-v-b7e5e046")
const _hoisted_1 = { class: "popup" }
const _hoisted_2 = {
  key: 0,
  class: "popup-wrap",
  ref: "PopUpRef"
}
const _hoisted_3 = { class: "wrap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "popup-wrap" }, {
      default: _withId(() => [
        (_ctx.isActive)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "content", { toggleDropdown: _ctx.toggleClass }, undefined, true)
              ])
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }),
    _createVNode("div", {
      class: "button",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleClass && _ctx.toggleClass(...args))),
      ref: "PopUpButtonRef"
    }, [
      _renderSlot(_ctx.$slots, "button", {}, undefined, true),
      (_ctx.isDefaultButton)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            class: "icon",
            mode: _ctx.buttonMode,
            size: "l",
            icon: _ctx.iconProps,
            "icon-only": ""
          }, null, 8, ["mode", "icon"]))
        : _createCommentVNode("", true)
    ], 512)
  ]))
})